import { useContext } from "react";
import { api } from "../../../../services/api";
import { GlobalAlertContext } from "../../../../contexts/GlobalAlertContext";

export default function usePdf() {
    const { handleLoading } = useContext(GlobalAlertContext)

    const generatePdf = async (param) => {
        handleLoading(true)
        try {
            const { data: pdf } = await api({ method: "get", url: "/source/pdf/"+param, });

            const data = Uint8Array.from(pdf.pdf.data);
            const content = new Blob([data.buffer], { type: "application/pdf" });
            const encodedUri = URL.createObjectURL(content);
            const link = document.createElement("a");
            
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", "analitico.pdf");
            
            link.click();

        } catch (error) {
            
        }
        handleLoading(false)
    };

    return {
        generatePdf
    }
}